module.exports = __webpack_public_path__ + "static/media/big_truck.98fdee0e.svg";